import React from 'react'
import HomePageBanner from '../Components/HomePageBanner'
import AIA from "../Components/AIA"
import axios from 'axios'
import { CircularProgress, Box } from '@material-ui/core'
const HomePage = () => {    
    const [isLoading, setLoading] = React.useState(false)
    const [stories, setStories] = React.useState({
        featured: [],
        trending: [],
        top_stories: [],
        recent: []
    })

    React.useEffect(()=>{
        setLoading(true)
        axios.get(`https://jtimes.zuddo.biz/main/api/stories`)
        .then((res)=>{
            if(res.data.status === 'success') {
                setStories(res.data.data);
            }
            setLoading(false)
        })
        .catch((err)=>{
            console.error('Error fetching stories:', err)
            setLoading(false)
        })
    }, [])    

    return (
        isLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress size={60} />
            </Box>
        ) : (
            <div style={{marginTop:"0px"}}>
          
                <div>
                    <HomePageBanner data={stories.featured}/>            
                </div>
                <div style={{ padding:'0', borderTop:'3px solid',  width:"91%", margin:"10px auto"}}></div>
  
                {stories.trending.length > 0 && (
                    <div style={{marginTop: "30px"}}>
                        <h2 style={{padding: "0 40px", marginBottom: "20px"}}>Trending Now</h2>
                        {stories.trending.map((article, idx) => (
                            <AIA
                                key={article.id || idx}
                                data={article}
                                imgUrl={article?.multimedia?.[0]?.url}
                                imgCaption={article?.multimedia?.[0]?.caption}
                            />
                        ))}
                    </div>
                )}
                
                <div style={{ padding:'0', borderTop:'3px solid',  width:"91%", margin:"10px auto"}}></div>
                
         
                {stories.top_stories.length > 0 && (
                    <div style={{marginTop: "30px"}}>
                        <h2 style={{padding: "0 40px", marginBottom: "20px"}}>Top Stories</h2>
                        {stories.top_stories.map((article, idx) => (
                            <AIA
                                key={article.id || idx}
                                data={article}
                                imgUrl={article?.multimedia?.[0]?.url}
                                imgCaption={article?.multimedia?.[0]?.caption}
                            />
                        ))}
                    </div>
                )}
                
                <div style={{ padding:'0', borderTop:'3px solid',  width:"91%", margin:"10px auto"}}></div>
                
             
                {stories.recent.length > 0 && (
                    <div style={{marginTop: "30px"}}>
                        <h2 style={{padding: "0 40px", marginBottom: "20px"}}>Recent News</h2>
                        {stories.recent.map((article, idx) => (
                            <AIA
                                key={article.id || idx}
                                data={article}
                                imgUrl={article?.multimedia?.[0]?.url}
                                imgCaption={article?.multimedia?.[0]?.caption}
                            />
                        ))}
                    </div>
                )}
            </div>
        )
    )
}

export { HomePage }